import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { mergeCssModules } from '@emoney/kyber-helpers';
import classNames$1 from 'classnames';
import React__default, { Component } from 'react';
import defaultCssModule from './less/popover-content.module.less.js';

var PopoverContent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PopoverContent, _Component);

  function PopoverContent() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = PopoverContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        cssModuleProp = _this$props.cssModule,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "cssModule"]);

    var cssModule = mergeCssModules(cssModuleProp, defaultCssModule);
    var classes = classNames$1(cssModule['content'], className);
    return /*#__PURE__*/React__default.createElement("div", _extends({
      className: classes
    }, restProps), children);
  };

  return PopoverContent;
}(Component);

PopoverContent.displayName = 'PopoverContent';

export default PopoverContent;
